import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// TODO
export function TooltipLabel({
  label,
  icon,
  children,
  labelProps,
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>

      {/* ラベル */}
      <Typography
        component="span"
        sx={{ pr: 1 }}
        {...labelProps}
      >
        {label}
      </Typography>

      {/* ツールチップ */}
      <Tooltip
        title={
          <Typography variant="body2">
            {children}
          </Typography>
        }
        enterDelay={300}
        leaveDelay={250}
        enterNextDelay={300}
      >
        {icon}
      </Tooltip>
    </Box>
  );
}

export default TooltipLabel;
